<nb-layout>
  <nb-layout-header fixed>
    <vmspdb-ui-header></vmspdb-ui-header>
  </nb-layout-header>

  <nb-layout-column>
    @if (updated$ | async) {
      <nb-alert outline="warning">
        New update available. Reload the web app to see the latest changes.
        <button nbButton status="basic" (click)="reloadServiceWorker()">
          Reload
        </button>
      </nb-alert>
    }

    <router-outlet></router-outlet>
  </nb-layout-column>

  <nb-layout-footer fixed>
    <div>
      <span>
        &copy; 2026. Running version
        <span
          class="btn-link"
          role="button"
          data-testid="footer-changelog-open"
          (click)="showChangelog()"
          >{{ version }}</span
        ></span
      >
    </div>
  </nb-layout-footer>

  <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
    <ng-container *ngrxLet="sidebarNavigation.menu$; let menu">
      <nb-menu [items]="menu" autoCollapse="true" tag="menu-sidebar"> </nb-menu>
    </ng-container>
  </nb-sidebar>
</nb-layout>
